import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

export const CBlogsection = ({ id }) => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        const response = await corefetch(`Blog/GetLatestBlogs?Id=${id}`);
        if (response && response.length > 0) {
          setBlogs(response);
        } else {
          setBlogs([]);
          console.error("No blog data found");
        }
      } catch (error) {
        setBlogs([]);
        console.error("Failed to fetch blog data", error);
      }
    };

    fetchBlogData();
  }, []);

  useEffect(() => {
    if (blogs?.length) {
      $(".blog-home .owl-carousel").owlCarousel({
        loop: true,
        margin: 30,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: false,
        navText: [
          "<span class='lnr ti-angle-left'></span>",
          "<span class='lnr ti-angle-right'></span>",
        ],
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 3,
          },
        },
      });
    }
  }, [JSON.stringify(blogs)]);

  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  const truncateDescription = (text, maxLength) => {
    const strippedText = stripHtmlTags(text);
    if (strippedText.length > maxLength) {
      return {
        short: `${strippedText.substring(0, maxLength)}...`,
        full: strippedText,
      };
    }
    return {
      short: strippedText,
      full: strippedText,
    };
  };

  if (!blogs || blogs.length === 0) {
    return null;
  }

  return (
    <section className="blog-home section-padding">
      <div className="container">
        <div className="row mb-30">
          <div className="col-md-3">
            <div className="sub-title border-bot-light">Our Blog</div>
          </div>
          <div className="col-md-9">
            <div className="section-title">Latest News</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="owl-carousel owl-theme">
              {blogs.map((blog, index) => {
                // Format the date
                const eventDate = new Date(blog.createdDate);
                const day = eventDate.getDate();
                const month = eventDate.toLocaleString("default", {
                  month: "short",
                });
                const year = eventDate.getFullYear();

                const truncated = truncateDescription(blog.description, 100);
                const encodedPath = blog.imagePath
                  .replace(/\(/g, "%28")
                  .replace(/\)/g, "%29")
                  .replace(/ /g, "%20");

                const fullURL = `${ImageURL}${encodedPath}`;
                return (
                  <div
                    key={index}
                    className="item bg-img"
                    style={{
                      backgroundImage: `url('${fullURL}')`,
                    }}
                  >
                    <div className="content">
                      <div className="info">
                        <span>
                          <i className="ti-time" aria-hidden="true" />
                          {`${month} ${day} ${year}`}
                        </span>
                      </div>
                      <a href={`/blogdetail/${blog.blogsID}`}>
                        <h5>{blog.title}</h5>
                      </a>

                      <p title={truncated.full}>{truncated.short}</p>
                      <div className="arrow">
                        <a href={`/blogdetail/${blog.blogsID}`}>
                          <span className="ti-arrow-right" />
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
